import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG, PRODUCT_NAME } from './constants';
interface TimeUnitProps {
  value: number;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="text-center" data-id="element-116" data-mp="1i3r6v9w9f25o">
      <div className="rounded-lg bg-brand-ink px-2.5 py-1.5 font-mono text-xl font-bold text-white shadow-inner sm:px-3 sm:text-2xl" data-id="element-117" data-mp="1i4sndtw1ogus">
        {String(value).padStart(2, '0')}
      </div>
      <p className="mt-0.5 text-[9px] font-bold tracking-wider text-brand-slate" data-id="element-118" data-mp="29unmgi9pfkwn">{label}</p>
    </div>;
}
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds > 0) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes > 0) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours > 0) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 1,
          minutes: 30,
          seconds: 5
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="offerta" className="border-y border-brand-gold/40 bg-brand-cloud px-4 py-6" data-id="element-119" data-mp="2ssokt4b537dk">
      <div className="mx-auto max-w-2xl" data-id="element-120" data-mp="2xr9c2e8eygpv">
        <div className="mb-3 text-center" data-id="element-121" data-mp="2jtl0xy45eny0">
          <p className="mb-1 font-display text-[11px] font-bold uppercase tracking-widest text-brand-navy sm:text-sm" data-id="element-122" data-mp="2jvxi49230ua0">
            OFFERTA SPECIALE — SISTEMA COMPLETO 6-IN-1
          </p>
          <p className="mb-2 text-sm font-semibold text-brand-ink sm:text-base" data-id="element-123" data-mp="29xhq83v8dgzg">
            Accedi subito al sistema completo e rivoluziona il modo in cui prepari i tuoi interventi terapeutici.
          </p>
          <div className="mb-2 inline-block rounded-lg bg-brand-navy px-3 py-1.5 text-white shadow-md" data-id="element-124" data-mp="827dhpc4y3yt">
            <p className="font-display text-xs font-bold tracking-wide sm:text-base" data-id="element-125" data-mp="d1agz5cgw24o">
              🩺 {PRODUCT_NAME} — Sistema Completo 6-in-1
            </p>
          </div>
          <a href={CHECKOUT_URL} className="block cursor-pointer" aria-label="Acquista Terapista Occupazionale Pro" data-id="element-126" data-mp="6ljtj3nb4fmh">
            <img src={PRODUCT_IMG} alt="Cofanetto Terapista Occupazionale Pro" className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-[260px]" data-id="element-127" data-mp="1q4hmh8v0tsp" />
          </a>
        </div>

        <div className="mb-3 rounded-2xl border-4 border-brand-gold bg-white p-4 text-center shadow-2xl sm:p-5" data-id="element-128" data-mp="pfys4s5pi69s">
          <p className="mb-1 text-sm font-semibold text-brand-slate" data-id="element-129" data-mp="glan9341mqli">
            Prezzo di Listino: <span className="line-through" data-id="element-130" data-mp="gjhp6c7hxep4">97€</span>
          </p>
          <p className="mb-1 font-display text-sm font-extrabold uppercase tracking-wide text-brand-navy sm:text-lg" data-id="element-131" data-mp="1d4rqswdpqs83">
            🔥 72% DI SCONTO — OFFERTA DI LANCIO A TEMPO LIMITATO
          </p>
          <p className="font-display text-4xl font-extrabold text-brand-ink sm:text-5xl" data-id="element-132" data-mp="2r0t3v6weolsj">Oggi Solo: 27€</p>
          <p className="mb-3 text-xs font-semibold text-brand-slate" data-id="element-133" data-mp="2vyl7uzabryd3">Pagamento sicuro nella tua valuta.</p>

          <div className="mb-3 rounded-xl border border-brand-navy/20 bg-brand-mint p-3" data-id="element-134" data-mp="302125oyx9mmm">
            <p className="mb-2 font-display text-[11px] font-bold uppercase leading-snug tracking-wide text-brand-navy sm:text-sm" data-id="element-135" data-mp="350axbzkncn88">
              ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
            </p>
            <div className="flex items-start justify-center gap-2.5" data-id="element-136" data-mp="3jnw01sdm0kfm">
              <TimeUnit value={timeLeft.hours} label="ORE" data-id="element-137" data-mp="3jop9x27v7q1z" />
              <span className="mt-1 text-xl font-bold text-brand-slate" data-id="element-138" data-mp="3npr1cwvjixte">:</span>
              <TimeUnit value={timeLeft.minutes} label="MINUTI" data-id="element-139" data-mp="3sou7kkn9ba2y" />
              <span className="mt-1 text-xl font-bold text-brand-slate" data-id="element-140" data-mp="3smhfhensbjc6">:</span>
              <TimeUnit value={timeLeft.seconds} label="SECONDI" data-id="element-141" data-mp="1ispvt8sdi8c" />
            </div>
          </div>
          <CTAButton href={CHECKOUT_URL} className="border-brand-navy/30 !bg-brand-gold !text-brand-ink shadow-[0_4px_14px_0_rgba(207,164,58,0.32)] hover:!bg-[#bb9231]" data-id="element-142" data-mp="3jzdfaxllt4d4">
            🚀 SÌ! VOGLIO TERAPISTA OCCUPAZIONALE PRO™ ORA
          </CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-bold text-brand-ink sm:text-sm" data-id="element-143" data-mp="3os6jnkd5uaoo">
          <div className="flex items-center gap-1" data-id="element-144" data-mp="313x1qtj2i72t">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-145" data-mp="2w4aq2oiw0yw4" />
            <span data-id="element-146" data-mp="3b0jo5mr1l66y">⭐⭐⭐⭐⭐ 4.9/5 — Recensioni Verificate dai Terapisti Occupazionali</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-147" data-mp="360x9d8vkfhw1">•</span>
          <div className="flex items-center gap-1" data-id="element-148" data-mp="qa0y9wkck8qb">
            <ShieldCheckIcon className="h-4 w-4 text-brand-navy" data-id="element-149" data-mp="q8pzkb5rdr62" />
            <span data-id="element-150" data-mp="lbhd3ydkv0z0">🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi</span>
          </div>
        </div>
      </div>
    </section>;
}